






















import { Vue, Prop, Component } from 'vue-property-decorator';

const vueCustomScrollbar = require('vue-custom-scrollbar');

@Component({
  components: {
    vueCustomScrollbar,
  },
})
export default class Table extends Vue {
  settings: Object = {
    maxScrollbarLength: 60,
  };

  @Prop({ type: Array, required: true, default: [] }) readonly lignes!: Array<Object>;

  compText(value: any) {
    if (value > 1) {
      return `${value} enfants sur la ligne`;
    }
    return `${value} enfant sur la ligne`;
  }

  get compLogo() {
    return require('@/assets/icons/PICTO_LIGNE_VIOLET.svg');
  }
}
